import * as React from "react";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import OnSaveViewAction from "views/logic/views/OnSaveViewAction";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useViewsDispatch from "views/stores/useViewsDispatch";
import SaveViewButton from "views/components/searchbar/SaveViewButton";
import useHotkey from "hooks/useHotkey";
import useView from "views/hooks/useView";
import useIsNew from "views/hooks/useIsNew";
import useHasUndeclaredParameters from "views/logic/parameters/useHasUndeclaredParameters";
const SaveDashboardButton = ({ userIsAllowedToEdit, openSaveAsModal, disabledInfo = void 0 }) => {
  const { t } = useTranslation("search");
  const view = useView();
  const isNewView = useIsNew();
  const sendTelemetry = useSendTelemetry("dashboard");
  const dispatch = useViewsDispatch();
  const hasUndeclaredParameters = useHasUndeclaredParameters();
  const _onSaveView = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DASHBOARD_ACTION.DASHBOARD_SAVED, {
      app_pathname: "dashboard",
      app_action_value: "dashboard-save"
    });
    return dispatch(OnSaveViewAction(view));
  }, [dispatch, sendTelemetry, view]);
  useHotkey({
    actionKey: "save",
    callback: () => isNewView ? openSaveAsModal() : _onSaveView(),
    scope: "dashboard",
    options: { enabled: !hasUndeclaredParameters && userIsAllowedToEdit }
  });
  return /* @__PURE__ */ React.createElement(
    SaveViewButton,
    {
      title: t("save_view.save_dashboard_title"),
      onClick: _onSaveView,
      disabled: hasUndeclaredParameters || isNewView || !userIsAllowedToEdit,
      disabledInfo
    }
  );
};
export default SaveDashboardButton;
